import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html'
})
export class HeaderComponent implements OnInit {

  reloadVisPage(){
    this.router.navigateByUrl('/', {skipLocationChange: true}).then(() => {
      this.router.navigate(['/vis']);
    });
  }

  constructor(private router: Router) {}

  // tslint:disable-next-line:typedef use-lifecycle-interface
  ngOnInit() {}

}
